import { message,Button, Col, ConfigProvider, Layout, Pagination, Popconfirm, Row, Statistic, Table, Input, Popover } from 'antd';
import { Content } from 'antd/lib/layout/layout';

import React, { useEffect, useRef, useState } from "react";
import OAMSider from '../oam-sider';
import Cookies from 'js-cookie';
import { sendHttpPostRequest } from '../../../api/http-request';
import Search from 'antd/lib/input/Search';
import zhCN from 'antd/lib/locale/zh_CN';
import GlobalCss from '@/global.module.less'
import PublicTipModal from '@/pages/components/PublicTipModal/PublicTipModal';
import { BACKEND_API_URL } from '../../../constants/constants'
import UserCard from '../user/oam-userinfo-card';


const channelMap = new Map([['爱数科', 1], ['爱数课', 2]]);

export interface Props {}

export const OAMChapterList: React.FC<Props> = () => {
    const [chapterResult, setChapterResult] = useState([] as any[]);  // 当前显示的结果页
    const [resultSum, setResultSum] = useState(0);  // 搜索返回的结果数
    const [totalCount, setTotalCount] = useState(0);  // 搜索返回的结果数

    const queryContent = useRef('');  // 记录搜索串
    const page = useRef(1);  // 记录当前的页数
    const pageSize = useRef(10);  // 记录当前每页展示数量

    const channelFilters = useRef([]);  // 渠道过滤项




  const newName = useRef('') // 名称
  const newDesc = useRef('') // 描述
  const [createModalVis, setCreateModalVis] = useState(false)
  const createOk = () => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      name: newName.current,
      description: newDesc.current,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('course/api/oam_create_chapter', data, (res) => {
      if (res.code == 0) {
        message.success('新建章节成功~')
        setCreateModalVis(false)
        queryChapterList()
      } else {
        message.error(res.message)
      }
    })
    newName.current = ''
    newDesc.current = ''
    
  }

  const createCancel = () => {
    setCreateModalVis(false)
    newName.current = ''
    newDesc.current = ''
  }

    useEffect(() => {
        queryChapterList();
    }, [])

    /**
     * 查询章节列表
     */
    const queryChapterList = () => {
        sendHttpPostRequest(
            'course/api/oam_query_chapter_list',
            {
                sessionid: Cookies.get("sessionid"), 
                page: page.current,
                pageSize: pageSize.current,
                query: queryContent.current
            },
            queryChapterListCallback
        )
    }

    /**
     * 查询章节列表回调
     * @param response
     */
    const queryChapterListCallback = (response: any) => {
        // console.log(response)
        message.destroy();
        if (response.code == -100) {
            // 未登录
            window.location.href = '/oam_login?next=oam_chapter';
        } else if (response.is_ok == true) {
            // 成功
            setChapterResult(response.query_list);
            //console.log(response)
            setResultSum(response.total_sum);
            setTotalCount(response.total_count);
            //setSysCount(response.sys_count);
            //setUserCount(response.user_count);
            //setOnlineCount(response.online_count);
        }// else if (response.code == -501) {
            // 权限不足
            //window.location.href = '/oam_login?next=oam_chapter';
        //} else {
            //message.error(response.message);
        //}
    }


    //页码和页数发生了变化
    const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
        page.current = newPage ? newPage : 1;
        if (newPageSize) {
            pageSize.current = newPageSize;
        }
        queryChapterList();
       
    }

   
    /**
     * 删除章节
     */
     const deleteChapter = (chapterId: string | number) => {
        sendHttpPostRequest(
            'course/api/oam_delete_chapter',
            {
                sessionid: Cookies.get("sessionid"),
                chapter_id: chapterId,
            },
            (response: any) => {
                // console.log(response)
                message.destroy();
                if (response.code == -100) {
                    // 未登录
                    window.location.href = '/oam_login?next=oam_chapter';
                } else if (response.is_ok == true) {
                    // 成功
                    message.success("删除成功");
                    //const newChapterResult = [...chapterResult];
                    const newChapterResult = chapterResult.filter(item=> item.id !== chapterId);
                    setChapterResult(newChapterResult);

                } /*else if (response.code == -501) {
                    // 权限不足
                    window.location.href = '/oam_login?next=oam_chapter';
                } */else {
                    message.error(response.message);
                }
            }
        )
    }


     //点击了查看按钮

  //点击了编辑按钮
  const onEditBtnClick = (event:any) => {
    //message.success('编辑数据' + event.currentTarget.value)
    event.preventDefault()
    window.open('/oam_chapter_edit?id=' + event.currentTarget.value)
  }

    //点击新建按钮


  // 点击 删除
  const onDeleteBtnClick = (name:string, id:number) => {
    deleteChapter(id)
  }


  // 点了上架按钮



    // 渲染操作
    const renderActions = (text:any, record:any) => {
        return <>
        <Row justify="start" align="middle" gutter={[8, 5]}  wrap={false}>
        {/*<Col style={{width:50}}><Button style={{borderRadius:20,fontSize:12}} size='small' id="lookover" value={record.id} type="default" onClick={onLookOverBtnClick} > 查 看 </Button></Col>*/}
        <Col style={{width:50}}><Button style={{borderRadius:20,fontSize:12}} size='small' id="edit" value={record.id} type="dashed" onClick={onEditBtnClick}> 编 辑 </Button> </Col>
            {/*{<Col style={{width:50}}> { parseInt(record.status) == 1 ? */}
            {/*<Button style={{borderRadius:20,fontSize:12}}  size='small' id="puton" value={record.id} type="primary"  onClick={onPutOnOffBtnClick.bind(this, record.id, record.name)}> 上 架 </Button>*/}
            {/*:  <Popconfirm placement="top" title={'确认下架章节"' + record.name + '"吗？'} onConfirm={onPutOnOffBtnClick.bind(this, record.id, record.name)} okText="确认" cancelText="取消">*/}
            {/*    <Button style={{borderRadius:20,fontSize:12}}  size='small' id="putoff" value={record.id} type="primary"  danger> 下 架 </Button>*/}
            {/*    </Popconfirm>}*/}
            {/*</Col> }*/}
            { <Col style={{width:50}}>
            <Popconfirm placement="top" title={'确认删除章节"' + record.name + '"吗？'} onConfirm={onDeleteBtnClick.bind(this, record.name,record.id)} okText="确认" cancelText="取消">
            <Button style={{borderRadius:20,fontSize:12}} size='small' id="delete" danger value={record.id} > 删 除 </Button> 
            </Popconfirm></Col> }
        </Row>

        </>

        }

 
  
    //点击了搜索按钮
    const onSearchBtn = (value: string) => {
        page.current = 1;
        queryContent.current = value;
        queryChapterList();
    }

    // 表格发生变化
    const onTableChange:any = (pagination:any, filters:any, sorter:any)=> {
        if (sorter.order) { //如果选择了排序列
            //order.current = sorter.order;
            //order_by.current = sorter.field;
        }
        if (filters.sex) { //如果选择了过滤列
            //sexFilters.current = filters.sex;
        } else {
            //sexFilters.current = [];
        }
        if (filters.channel_name) {
            channelFilters.current = filters.channel_name.map(element=> {
                return channelMap.get(element);
            });
        } else {
            channelFilters.current = [];
        }
        page.current = 1;
        //queryUserInfo();
    }

    // 表格列
    const cols: any = [
        {
            title: "序号",
            dataIndex: "id",
            key: "id",
            width: 80,
            align: 'left',
        },
        {
            title: "名称",
            dataIndex: "name",
            key: "name",
            width: 150,
            align: 'left',
            ellipsis: true,
        },
        {
            title: "描述",
            dataIndex: "description",
            key: "description",
            width: 250,
            align: 'left',
            ellipsis: true,
        },
        {
            title: '创建者',
            dataIndex: 'creator_name',
            key: 'creator_name',
            width: 150,
            align: 'left',
            ellipsis: true,
            render: (text, record) => {
                return (
                  <Row align="middle" wrap={false}>
                    <Col flex="40px">
                      <Popover
                        arrowPointAtCenter={true}
                        trigger="hover"
                        placement="left"
                        content={<UserCard user_id={record?.creator_id} />}
                        title={null}
                      >
                        <img
                          onMouseOver={() => {}}
                          style={{
                            width: 30,
                            height: 30,
                            borderRadius: 15,
                            cursor: 'pointer',
                          }}
                          src={
                            record?.creator_avatar?.startsWith('http')
                              ? record?.creator_avatar
                              : BACKEND_API_URL + record?.creator_avatar
                          }
                        />
                      </Popover>{' '}
                    </Col>
                    <Col flex="auto">
                      <span>{text}</span>
                    </Col>
                  </Row>
                )
              },
        },
        {
            title: '创建时间',
            dataIndex: 'create_time',
            key: 'create_time',
            width: 200,
            align: 'left',
        },
        {
            title: "操作",
            dataIndex: "actions",
            key: "actions",
            width: 160,
            ellipsis: false,
            align: 'center',
            fixed: 'right',
            render: renderActions ,
        },
    ]

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <OAMSider keys={"4"} openKeys={["sub-project"]}  ></OAMSider>
            <Layout style={{backgroundColor:'#f9f9f9'}}>
                <Content style={{ backgroundColor:'#fff',borderRadius:5,minWidth:400,margin:30 ,paddingTop:20}}>
                
                    <div style={{paddingLeft:30,paddingRight:30}}>
                    <Row align="middle"  gutter={16}>
                        <Col flex='80px'>
                            <Statistic title="章节总数" value={totalCount} />
                        </Col>
                        
                        <Col flex='250px'>
                            <Search
                                placeholder="搜索章节"
                                style={{ width: 350 }}
                                enterButton={true}
                                onSearch={onSearchBtn}
                            />

                        </Col>
                       
                        <Col flex='auto' style={{textAlign:'right'}}> <Button style={{borderRadius:20}} type={'primary'} onClick={()=>{setCreateModalVis(true)}}>+ 新 建</Button></Col>
                        </Row>
                      

                        <div style={{height:500}} className={GlobalCss.tableWrapper}>
                        <ConfigProvider locale={zhCN}>
                            <Table
                                dataSource={chapterResult}
                                columns={cols}
                                rowKey={record => record.id}
                                pagination={false}
                                scroll={{ x: 800 }}
                               // bordered={true}
                                onChange={onTableChange}
                            />
                        </ConfigProvider>
                        </div>

                        <ConfigProvider locale={zhCN}>
                            <div style={{marginBottom:30,paddingTop:30,textAlign:"center"}} className={"css.pagination"} >
                                <Pagination
                                    defaultCurrent={1}
                                    total={resultSum}
                                    current={page.current}
                                    defaultPageSize={10}
                                    hideOnSinglePage={true}
                                    onChange={onPageChange}
                                    showQuickJumper={true}
                                    showTotal={total => `共 ${total} 章节`}
                                    pageSizeOptions={["10","20","50","100"]}
                                />
                            </div>
                        </ConfigProvider>
                    </div>


                    <PublicTipModal
          modalContent={<div>
            <Row align={'middle'} justify={'start'} className={GlobalCss.formRow}>
            <Col className={GlobalCss.requiredLabel}>名称</Col>
            <Col>
              <Input
                style={{
                  width: '300px',
                }}
                placeholder="请输入章节名称"
                maxLength={50}
                onChange={(e) => {
                 newName.current = e.target.value
                }}
              />
            </Col>
          </Row>
          <Row align={'top'} justify={'start'} className={GlobalCss.formRow} style={{marginTop:15}}>
            <Col className={GlobalCss.requiredLabel}>描述</Col>
            <Col>
              <Input.TextArea
                style={{
                  minHeight: '145px',
                  width: '300px',
                }}
                placeholder="请输入章节描述"
                onChange={(e) => {newDesc.current = e.target.value}}
              />
            </Col>
          </Row>
          </div>
          }
          modalTitle={'创建章节'}
          handleOk={createOk}
          handleCancel={createCancel}
          open={createModalVis}
          setOpen={setCreateModalVis}
        />
                </Content>
            </Layout>
        </Layout>

    )

}

export default OAMChapterList


